import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export function fordealInWarehouse(data) {
  console.log(data);
  return axios.request({
    url: "/tool/fordealInWarehouse",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}
